<template>
  <ModalComponent ref="marketPriceModal" :submitButtonText="$t('common.close')">
    <template #title>
      <h4>{{ $t("setPriceTerms.howMarketPriceWorks") }}</h4>
    </template>
    <template #body>
      <div class="p-3">
        <p class="mb-3 lh-lg">
          {{ $t("setPriceTerms.marketPriceContentParagraph1") }}
        </p>
        <p class="mb-3 lh-lg">
          {{ $t("setPriceTerms.marketPriceContentParagraph2") }}
        </p>
        <p class="mb-3 lh-lg">
          {{ $t("setPriceTerms.marketPriceContentParagraph3") }}
        </p>
        <div class="mb-3 lh-lg">
          <a
            :href="$t('links.trading_procedure')"
            target="_blank"
            rel="noopener noreferrer"
            class="text-decoration-underline fw-semibold"
          >
            {{ $t("links.trading_procedure_text") }}
            <font-awesome-icon icon="fa-solid fa-external-link" size="sm" />
          </a>
        </div>
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import { useTemplateRef } from "vue";
import ModalComponent from "@/components/common/ModalComponent.vue";

const marketPriceModal =
  useTemplateRef<InstanceType<typeof ModalComponent>>("marketPriceModal");

const toggleModal = () => {
  if (marketPriceModal.value) {
    marketPriceModal.value.toggleModal();
  }
};

defineExpose({
  toggleModal,
});
</script>
